import { connect } from 'react-redux';
import Selector from './Selector';
import { setActiveMyAuthTab } from '../../store/myAuthorizationsSlice';
import { resetCardFilters, setFilters } from '../../../filters/store/filtersSlice';
import { setMobileDrawerOpen } from '../../../mobile-drawer/store/mobileDrawerSlice';

const mapState = state => ({
  selectedIndex: state.loadingManagement.filters.selectedIndex,
});

const mapDispatchToProps = {
  resetCardFilters,
  setActiveMyAuthTab,
  setFilters,
  setMobileDrawerOpen,
};

export default connect(mapState, mapDispatchToProps)(Selector);
